module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Search.425985a8.svg";